<template>
  <div>
    <search
      :title="`${$t('modal.customer')}`"
      :items="customers"
      idProperty="CustomerId"
      nameProperty="CustomerName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />

    <customer-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import customerSelect from "@/components/selects/CustomerSelects";

export default {
  data() {
    return {
      trigger: false,
      customers: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Customer) {
        this.customers = value.Customer;
      }
    },
  },
  components: {
    search,
    customerSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.customers];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.customers = items;
      this.set();
    },
    remove(index) {
      if (!this.customers[index]) return;
      this.customers.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.customers);
    },
  },
};
</script>
